module.exports = __webpack_public_path__ + "static/media/tw-logo1.8ceb6173.png";